import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_be6rwkua52: FaireBrandEntity = {
  token: "b_be6rwkua52",
  type: "brand",
  name: "Bridgewater Candle Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/c97ba2d27943471c9b20a06bda0371a16050090c06f1777b7e07f052dea7b87d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1b68819f2bd9ba0691162e4a2d4f27b44835c7da67aa393a4cc7a50636312336.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c97ba2d27943471c9b20a06bda0371a16050090c06f1777b7e07f052dea7b87d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1b68819f2bd9ba0691162e4a2d4f27b44835c7da67aa393a4cc7a50636312336.jpeg",
  location: "Spartanburg, SC, USA",
  minimumOrderDollars: 500,
  rating: 4.8,
  reviewCount: 56,
  isInsider: true,
  description:
    "At Bridgewater Candle Company, we create obsession-worthy fragrances designed to bring you joy. That’s why, since 1998, our feel-good, do-good brand has developed home fragrances perfect for every corner of your life – from house to car to laundry – making each space smell so good you’ll never want to leave. With every candle purchase, we’re committed to feeding orphans through our Light A Candle Feed a Child™ mission, making it even easier to love a scent and give back to those in need. Join us in experiencing the joy a candle can make!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:24.895Z",
    importedBy: "entity-db-cli",
  },
};
